import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { Link } from 'react-router-dom';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Timeline from "@material-ui/icons/Timeline";
import Code from "@material-ui/icons/Code";
import Email from "@material-ui/icons/Email";
import School from "@material-ui/icons/School";
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import PreLoginHeader from "components/Header/PreLoginHeader.jsx";

import registerPageStyle from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import { setSessionOnLogin } from "../../assets/helpers/loginHelper";
import { verifyPassword, verifyEmail } from "../../assets/helpers/formHelper";
import { API_ROOT, HOST_ADDRESS } from 'api-config';

const agreementType = 'assessmentAgreement'
const agreementLink = HOST_ADDRESS + "/agreement?type=" + agreementType
const userType = 'assessment'

class RegisterPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      agree: false,
      email: "",
      password: "",
      responseMessage: "",
      inputDisabled: false
    };
    this.handleToggle = this.handleToggle.bind(this);
  }
  handleToggle(value) {
    const newAgree = !this.state.agree

    this.setState({
      agree: newAgree
    });
  }
  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = event => {
    var proceed = true
    if (!verifyEmail(this.state.email)) {
      proceed = false
      alert('that is not a valid email')
    } else if (!verifyPassword(this.state.password)) {
      proceed = false
      alert('that is not a valid password')
    } else if (!this.state.agree) {
      proceed = false
      alert('please check the box to indicate you agree to the user agreement')
    }
    const userInfo = {
      email: this.state.email,
      password1: this.state.password,
      userType: userType
    }
    const agreement = {
      agree: this.state.agree,
      fileName: agreementType,
      fullAgreementViewed: false
    }
    const submitData = {
      userInfo: JSON.stringify(userInfo),
      agreement: JSON.stringify(agreement)
    }
    if (proceed) {
      this.setState({
        inputDisabled: true
      })
      axios.post(`${API_ROOT}/register/`, submitData, { headers: getApiHeaders() })
          .then(res => this.handleRegistrationResponse(res.data));
    }
  }
  handleRegistrationResponse(res) {
    if (res.message.status && res.message.status === 'success') {
      const loginData = {
        username: this.state.email,
        password: this.state.password
      }

      axios.post(`${API_ROOT}/auth/login/`, loginData, { headers: getApiHeaders() })
        .then(res => this.handleLoginResponse(res.data));

    } else {
      this.setState({
        inputDisabled: false
      })
      var error
      if (res.message.status) {
        error = res.message.status
      } else {
        error = res.message.error
      }
      alert("There was an error setting up your account: " + error)
    }

  }
  handleLoginResponse(res) {
    if (!res.message) { // if there is not an error
      setSessionOnLogin(res)
      var redirectTo = '/'
      window.location = redirectTo;
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <PreLoginHeader />
        <GridContainer justifyContent="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card className={classes.cardSignup}>
              <h2 className={classes.cardTitle}>Register</h2>
              <CardBody>
                <GridContainer justifyContent="center">
                  <GridItem xs={12} sm={12} md={5}>
                    <InfoArea
                      title="Free Practice Assessment"
                      description="Complete a free practice assessment to determine if any insurers are bad for the financial health of your office."
                      icon={Timeline}
                      iconColor="cirrusOrange"
                    />
                    <InfoArea
                      title="Model Your Membership Program"
                      description="Our proprietary algorithm will model what a membership program would look like in your office and help you determine whether to start a program."
                      icon={Code}
                      iconColor="cirrusOrange"
                    />
                    <InfoArea
                      title="Learn The Next Steps"
                      description="If you decide a membership program makes sense, we'll help you take the next steps toward a successful program."
                      icon={School}
                      iconColor="cirrusOrange"
                    />
                  </GridItem>
                  <GridItem xs={12} sm={8} md={5}>
                    <form className={classes.form}>
                      <CustomInput
                        id="email"
                        formControlProps={{
                          fullWidth: true,
                          className: classes.customFormControlClasses
                        }}
                        inputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              className={classes.inputAdornment}
                            >
                              <Email className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          placeholder: "Email...",
                          onChange: this.handleChange,
                          autoFocus: true,
                          disabled: this.state.inputDisabled
                        }}
                      />
                      <CustomInput
                        id="password"
                        formControlProps={{
                          fullWidth: true,
                          className: classes.customFormControlClasses
                        }}
                        inputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              className={classes.inputAdornment}
                            >
                              <Icon className={classes.inputAdornmentIcon}>
                                lock_outline
                              </Icon>
                            </InputAdornment>
                          ),
                          placeholder: "Password...",
                          onChange: this.handleChange,
                          type: "password",
                          disabled: this.state.inputDisabled
                        }}
                      />
                      <FormControlLabel
                        classes={{
                          root: classes.checkboxLabelControl,
                          label: classes.checkboxLabel
                        }}
                        control={
                          <Checkbox
                            tabIndex={-1}
                            onClick={() => this.handleToggle(1)}
                            checkedIcon={
                              <Check className={classes.checkedIcon} />
                            }
                            icon={<Check className={classes.uncheckedIcon} />}
                            classes={{
                              checked: classes.checked,
                              root: classes.checkRoot
                            }}
                          />
                        }
                        label={
                          <span>
                            I agree to the{" "}
                            <a href={agreementLink} target="_blank" rel="noopener noreferrer">terms and conditions</a>.
                          </span>
                        }
                      />
                      <div className={classes.center}>
                        <GridItem xs={12} sm={12} md={12}>
                          <Button round color="cirrusBlue" disabled={this.state.inputDisabled} onClick={this.handleSubmit}>
                            Get started
                          </Button>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          Already have an account? <Link className={classes.linkClass} to="/login">Log in here.</Link>
                        </GridItem>
                      </div>
                    </form>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

RegisterPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(registerPageStyle)(RegisterPage);
